import { render, staticRenderFns } from "./safety-pin.vue?vue&type=template&id=5e4199f2&scoped=true"
import script from "./safety-pin.vue?vue&type=script&lang=js"
export * from "./safety-pin.vue?vue&type=script&lang=js"
import style0 from "./safety-pin.vue?vue&type=style&index=0&id=5e4199f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4199f2",
  null
  
)

export default component.exports